// Welcome screen in ra sau `npm install -g` (qua postinstall hook) hoặc khi
// user gọi `avatar welcome` thủ công. Mục đích: cho user thấy banner + toàn bộ
// commands (COMMANDS.length) + next step gợi ý ngay sau khi cài.
import boxen from "boxen";
import { printAvatarBanner } from "./avatar-ascii-banner.js";
import { readCliVersion } from "./read-cli-version-from-package-json.js";
import { chalk } from "./terminal-logger.js";

export interface CommandSummary {
  name: string;
  desc: string;
}

// Danh sách commands user-facing (mcp-run, print-id-token là hidden, bỏ qua).
// Đếm count = COMMANDS.length (không hardcode số).
// EXPORTED: init-success-rendering-and-helpers.ts tái dùng để liệt kê đầy đủ lệnh
// trong box init-success — tránh 2 nguồn danh sách lệnh lệch nhau (DRY).
export const COMMANDS: CommandSummary[] = [
  { name: "login", desc: "Đăng nhập Google SSO (@nal.vn)" },
  { name: "logout", desc: "Đăng xuất — revoke token + xóa credential" },
  { name: "init", desc: "Khởi tạo Avatar — 3 flow tự nhận diện" },
  { name: "sync", desc: "Pull team-ai-pack mới nhất" },
  { name: "scan", desc: "Project scanner + knowledge proposal" },
  { name: "review", desc: "Duyệt pending proposals" },
  { name: "status", desc: "Snapshot project, pack, pending, backup" },
  { name: "doctor", desc: "Chẩn đoán cài đặt Avatar" },
  { name: "restore", desc: "Khôi phục .claude/pack/ từ backup" },
  { name: "tools", desc: "Quản lý system tools + MCP servers" },
  { name: "ai", desc: "Cấu hình AI provider (setup/status/test/reset)" },
  { name: "comm-connect", desc: "Kết nối Mattermost (bot @avatar) để giao/nhận spec" },
  { name: "gitnexus", desc: "Quản lý GitNexus code intelligence" },
  { name: "debate", desc: "2-agent phản biện plan/doc" },
  { name: "pack", desc: "Xem version / trạng thái pack" },
  { name: "add", desc: "Thêm tài nguyên (repo) vào workspace" },
  { name: "uninstall", desc: "Gỡ Avatar khỏi project + backup" },
  { name: "update", desc: "Tự cập nhật Avatar CLI qua npm" },
  { name: "help", desc: "Hiển thị help cho từng lệnh" },
];

export function printWelcomeScreen(): void {
  printAvatarBanner({ tagline: `v${readCliVersion()} · AI harness CLI for NAL Vietnam` });

  // Tính độ rộng max của tên command để align cột.
  const maxNameWidth = Math.max(...COMMANDS.map((c) => c.name.length));

  const commandLines = COMMANDS.map((c) => {
    const padded = c.name.padEnd(maxNameWidth);
    return `  ${chalk.cyan(padded)}   ${chalk.dim(c.desc)}`;
  }).join("\n");

  const nextSteps = [
    "",
    chalk.bold(`${COMMANDS.length} lệnh sẵn sàng:`),
    "",
    commandLines,
    "",
    chalk.bold("Next steps:"),
    "",
    `  ${chalk.green("1.")} ${chalk.cyan("avatar login")}                    Đăng nhập SSO`,
    `  ${chalk.green("2.")} ${chalk.cyan("avatar init")}                     Khởi tạo dự án`,
    `  ${chalk.green("?.")} ${chalk.cyan("avatar <command> --help")}         Xem chi tiết lệnh`,
    "",
    chalk.dim("Docs: https://www.npmjs.com/package/@nalvietnam/avatar-cli"),
  ].join("\n");

  process.stdout.write(
    `${boxen(nextSteps, { padding: 1, borderStyle: "round", borderColor: "magenta" })}\n`,
  );
}

// Caller (bin/postinstall.js) chịu trách nhiệm gọi printWelcomeScreen() —
// không auto-execute ở đây để tránh in trùng khi module được import từ postinstall.
